import DebutPanel from '@/components/phone/debut';
import { Title } from '@/components/phone/Title';
import { useCurrentUser } from '@/hooks';
import { getNewDebutTellers } from '@raysee/firestore';
import { isDisabledTeller, PlanType } from '@raysee/schema';
import type { NextPage } from 'next';
import { NextSeo } from 'next-seo';
import { useMemo, useState } from 'react';
import useSWR from 'swr';
import { Container, Header, Main, TabMenu, withLayout } from '../../../components';

const PER_GET_ONE = 10;

const Page: NextPage = () => {
  const { data } = useSWR('debut_tellers', () => getNewDebutTellers(), {
    revalidateOnMount: true,
    revalidateOnFocus: false,
  });

  const { user } = useCurrentUser();

  const [showNum, setShowNum] = useState(PER_GET_ONE);

  const showList = useMemo(() => {
    if (data) {
      return data
        .filter((teller) => teller.newDebutPlanType !== PlanType.Chat && !isDisabledTeller(teller))
        .slice(0, showNum);
    }
    return [];
  }, [data, showNum]);

  return withLayout(
    <Container>
      <NextSeo
        title="最新デビューの占い師 | 電話占いRAYSEE｜4,200円分無料、1分220円~｜口コミで当たると評判の電話レイシー"
        description="電話占いRAYSEEに新たにデビューした電話占い師をご紹介します。電話占いRAYSEEでは、お相手の気持ちや復縁の可能性、不倫や複雑な恋愛等の皆様のお悩みに合わせた電話占い師を厳選しております。"
      />
      <Header />
      <Main>
        <div className="p-3 space-y-10">
          <Title title="デビュー占い師" isCenter />
          {showList.map((teller) => (
            <DebutPanel key={teller.id} teller={teller} />
          ))}
        </div>
        {/* {isLoading ? (
          <Loading size={12} color="border-t-rose-400" />
        ) : (
          <div className="flex justify-center mx-4">
            <button
              type="button"
              className="text-sm border border-gray-400 text-gray-400 font-bold py-3 px-10 rounded-full inline-flex items-center justify-center flex-1"
              onClick={onShowMore}
            >
              もっと見る
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 256 256"
                className="rotate-90"
              >
                <title>more</title>
                <path
                  fill="currentColor"
                  d="m184.49 136.49l-80 80a12 12 0 0 1-17-17L159 128L87.51 56.49a12 12 0 1 1 17-17l80 80a12 12 0 0 1-.02 17"
                />
              </svg>
            </button>
          </div>
        )} */}
      </Main>
      <TabMenu isLogin={!!user} />
    </Container>,
  );
};

export default Page;
